<template>
    <div class="article-block">
        <HorizontalScroll class="tabs" ref="tab">
            <div
                v-for="(item, index) in typeList"
                :key="index"
                :class="{ active: tabIndex === index }"
                @click="goFilter(item.typeId, index)">
                {{ item.typeName }}
            </div>
        </HorizontalScroll>

        <div v-for="(item, idx) in typeList" :key="idx" v-show="tabIndex === idx">

            <div class="no-data" v-if="dataList[idx].length === 0">
                <img src="../../assets/images/empty.svg">
                <p>目前沒有貼文</p>
            </div>

            <div class="container" v-else>
                <div class="list-style"
                     v-for="(article, index) in dataList[idx]"
                     :key="index"
                     @click="goDetail(article)">
                    <el-image :src="article.titleImage" fit="cover" class="pic3"/>
                    <div class="content">
                        <p class="date2">{{ article.createdAt.slice(0, 16) }}</p>
                        <h4>{{ article.title }}</h4>
                        <NewsFunction :viewCount="article.viewCount" :messageCount="article.messageCount"/>
                    </div>
                </div>
            </div>

            <infinite-loading
                v-if="isSetupList"
                :identifier="infiniteId[idx]"
                spinner="waveDots"
                @infinite="onInfiniteLoad($event, idx)">
                <div slot="no-more">沒有更多資料</div>
                <div slot="no-results"></div>
            </infinite-loading>
        </div>

        <loading
            :active.sync="isLoading"
            :can-cancel="false"
            :is-full-page="true">
        </loading>
    </div>
</template>

<script>
    import NewsFunction from '@/components/NewsFunction.vue'
    import * as constDefine from "@/store/constDefine";
    import crypto from "@/util/crypto";
    import HorizontalScroll from "@/components/HorizontalScroll"
    export default {
        name: "MarketplaceArticle",
        components: {
            NewsFunction,
            HorizontalScroll,
        },
        data() {
            return {
                isLoading: false,
                shopAreaId: 0,
                dataToken: this.$route.query.dataToken !== undefined ? this.$route.query.dataToken : "",
                dataObject: {},
                dataList: [[], []],
                isSetupList: false,
                offset: [0],
                pageSize: 10,
                infiniteId: [],

                //目前選到的 tab的索引值
                tabIndex: 0,
                //文章分類
                typeList: [{typeId: -1, typeName: "總覽"}],
            }
        },
        async created() {
            if (this.dataToken !== "") {
                this.initForDataToken(this.dataToken);
            } else {

                try {
                    this.shopAreaId = Number(this.$store.state.shopAreaInfo.id)
                } catch (e) {
                    this.shopAreaId = Number(this.$route.query.shopAreaId) || 0
                }

            }
            await this.getArticleType();

            const typeId = Number(this.$route.query.articleType);
            const idx = this.typeList.findIndex(item => item.typeId === typeId);

            if (idx !== -1) {
                this.tabIndex = idx;
                if(this.shopAreaId > 0) {
                    this.isSetupList = true;
                }
            } else {
                if (this.$route.query.articleType === undefined) {
                    this.tabIndex = 0;
                    if (this.shopAreaId > 0) {
                        this.isSetupList = true;
                        await this.$router.replace({
                            query: {
                                ...this.$route.query,
                                articleType: this.typeList[0]?.typeId ?? -1,
                            }
                        });
                    }
                } else {
                    await this.$router.push({name: 'Error'});
                }
            }
        },
        methods: {
            initForDataToken(item) {
                try {
                    this.dataObject = this.$crypto.uriComponentToObject(item);

                    if (this.$public.notNull(this.dataObject) &&
                        this.$public.notNull(this.dataObject.shopAreaId)) {
                        this.shopAreaId = this.dataObject.shopAreaId;
                        this.isSetupList = true;
                    }

                } catch (e) {
                    this.$router.push({name: 'Error'});
                    return false;
                }
            },
            // setupData($state) {
            //     this.isLoading = true
            //     this.$http.fetchWithEncrypt`GetArticleListByObject${{
            //         'objectType': constDefine.MerchantType.ShoppingArea,
            //         'objectId': this.shopAreaId,
            //         'status': 1,
            //         'isRelease': true,
            //         'offset': this.offset[this.tabIndex],
            //         'pageSize': this.pageSize,
            //         'articleTypeId': this.typeId,
            //     }}
            //     ${json => {
            //         if (json.status) {
            //             if (json.data.length >= this.pageSize) {
            //                 this.offset[this.tabIndex]++;
            //                 this.dataList[this.tabIndex].tmz_load_push(...json.data);
            //                 $state.loaded();
            //             } else {
            //                 this.offset[this.tabIndex]++;
            //                 this.dataList[this.tabIndex].tmz_load_push(...json.data);
            //                 $state.complete();
            //             }
            //         }
            //         this.isLoading = false
            //         this.$emit('isArticle', this.dataList[this.tabIndex].length !== 0);
            //     }}`
            // },
            onInfiniteLoad($state, idx) {
                this.loadArticleList($state, idx);
            },
            loadArticleList($state, idx) {
                this.isLoading = true;
                this.$http.fetchWithEncrypt`GetArticleListByObject${{
                    'objectType': constDefine.MerchantType.ShoppingArea,
                    'objectId': this.shopAreaId,
                    'status': 1,
                    'isRelease': true,
                    'offset': this.offset[idx],
                    'pageSize': this.pageSize,
                    'articleTypeId': this.typeList[idx].typeId,
                }}
	            ${json => {
                    if (json.status) {
                        this.offset[idx]++;
                        this.dataList[idx].tmz_load_push(...json.data);

                        if (json.data.length >= this.pageSize) {
                            $state.loaded();
                        } else {
                            $state.complete();
                        }

                        if (idx === 0) {
                            this.$emit('isArticle', this.dataList[idx].length !== 0);
                        }
                    }
                    this.isLoading = false;
                }}`
            },
            getArticleType() {
                return new Promise(resolve => {
                    this.$http.fetch`ArticleTypeList${{
                        'objectType': constDefine.MerchantType.ShoppingArea,
                        'objectId': this.shopAreaId,
                        'isAddOverview': true,
                    }}
                    ${json => {
                        this.typeList = json.data;
                        this.dataList = this.typeList.map(() => []);
                        this.offset = this.typeList.map(() => 0);
                        this.infiniteId = this.typeList.map(() => +new Date());
                        resolve();
                    }}`
                })
            },
            goDetail(item) {
                let routerName = "MarketplaceArticleDetail"
                this.$router.push({name: routerName, query: {'code': item.code}})
            },
            goFilter(typeId, index) {
                if (this.tabIndex === index) return;
                this.tabIndex = index;
                this.$router.push({
                    query: {
                        ...this.$route.query,
                        articleType: typeId,
                    },
                });
                if (this.dataList[index].length === 0) {
                    this.infiniteId[index] = +new Date();
                }
            },
        },
        beforeRouteUpdate(to, from, next) {
            const hasQueryInTo = Object.keys(to.query).length > 0;
            const currentArticleType = this.$route.query.articleType;

            if (!hasQueryInTo && currentArticleType === '-1') {
                next(false);
                return;
            }

            const typeId = Number(to.query.articleType);
            const idx = this.typeList.findIndex(item => item.typeId === typeId);

            if (to.query.articleType === undefined) {
                this.$router.replace({
                    query: {
                        ...to.query,
                        articleType: this.typeList[0]?.typeId ?? -1,
                    }
                });
                return next(false);
            }

            if (Number.isNaN(typeId) || idx === -1) {
                this.$router.push({ name: 'Error' });
                return next(false);
            }

            this.tabIndex = idx;
            this.typeId = typeId;

            if (this.dataList[idx].length === 0) {
                this.infiniteId[idx] = +new Date();
            } else {
                this.$nextTick(() => {
                    this.loadArticleList({
                        loaded: () => {},
                        complete: () => {}
                    }, idx);
                });
            }

            next();
        }
    }
</script>

